module.exports = __webpack_public_path__ + "static/08-3-26cf5d0c8fc57b86915c751c365f302e.jpg";